import integrationStoreMutations from '@/state/integrationStore/integrationStoreMutations'
import integrationStoreActions from '@/state/integrationStore/integrationStoreActions'
import getIntegrationsStoreDefaultState from '@/state/integrationStore/integrationStoreDefaultState'

let state = getIntegrationsStoreDefaultState()

export const integrationStore = {
  namespaced: true,
  state,
  mutations: integrationStoreMutations,
  getters: {
    isSalesForceConnected: state => {
      return state.integrations.some(
        integration => integration.provider === 'salesforce'
      )
    }
  },
  actions: integrationStoreActions
}
